export default {
    setIsPaymentSetup(context, status) {
        context.isPaymentSetup = status
    }
}